/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  SignTypedMessageLib,
  SignTypedMessageLibInterface,
} from "../../../contracts/periphery/SignTypedMessageLib";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "CalldataOutOfBounds",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "msgHash",
        type: "bytes32",
      },
    ],
    name: "SignMsg",
    type: "event",
  },
  {
    stateMutability: "nonpayable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "deployedAt",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "message",
        type: "bytes",
      },
    ],
    name: "hashSafeMessage",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "domain",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "message",
        type: "bytes",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "enum AbiType",
                name: "_type",
                type: "uint8",
              },
              {
                internalType: "uint256[]",
                name: "fields",
                type: "uint256[]",
              },
            ],
            internalType: "struct AbiTypeTree[]",
            name: "typeTree",
            type: "tuple[]",
          },
          {
            internalType: "bytes32[]",
            name: "typeHashes",
            type: "bytes32[]",
          },
        ],
        internalType: "struct EIP712Encoder.Types",
        name: "types",
        type: "tuple",
      },
    ],
    name: "hashTypedSafeMessage",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "message",
        type: "bytes",
      },
    ],
    name: "signMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "domain",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "message",
        type: "bytes",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "enum AbiType",
                name: "_type",
                type: "uint8",
              },
              {
                internalType: "uint256[]",
                name: "fields",
                type: "uint256[]",
              },
            ],
            internalType: "struct AbiTypeTree[]",
            name: "typeTree",
            type: "tuple[]",
          },
          {
            internalType: "bytes32[]",
            name: "typeHashes",
            type: "bytes32[]",
          },
        ],
        internalType: "struct EIP712Encoder.Types",
        name: "types",
        type: "tuple",
      },
    ],
    name: "signTypedMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type SignTypedMessageLibConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SignTypedMessageLibConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SignTypedMessageLib__factory extends ContractFactory {
  constructor(...args: SignTypedMessageLibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      SignTypedMessageLib & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): SignTypedMessageLib__factory {
    return super.connect(runner) as SignTypedMessageLib__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SignTypedMessageLibInterface {
    return new Interface(_abi) as SignTypedMessageLibInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): SignTypedMessageLib {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as SignTypedMessageLib;
  }
}
